export const GetOcplcProductGroupDropDown = `query GetOcplcProductGroupDropDown {
  oplcProductGroupDropDown {
    ocplcProductGroups {
      productGroup
    }
  }
}`;